import React from 'react';
const LightningIcon = () => {
  return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.95133 9.91386L10.15 4.28561C10.5636 3.73118 11.4119 4.03801 11.4119 4.74205V8.14852C11.4119 8.55754 11.728 8.88911 12.1179 8.88911H13.4927C14.0812 8.88911 14.4113 9.6 14.0487 10.0861L9.84999 15.7144C9.43638 16.2688 8.5881 15.962 8.5881 15.2579V11.8515C8.5881 11.4425 8.27203 11.1109 7.88215 11.1109H6.50727C5.91883 11.1109 5.58867 10.4 5.95133 9.91386Z" fill="none" stroke="#fff" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>
};

export default LightningIcon;